import type {
  OrganizationBranding
} from "@camp-points/shared";
import type {
  PropsWithChildren
} from "react";

interface Props extends PropsWithChildren {
  branding?: OrganizationBranding;
  eyebrow?: string;
}

export function BrandShell({
  branding,
  eyebrow,
  children
}: Props) {
  const style = {
    "--brand-primary":
      branding?.primaryColor ??
      "#245743",
    "--brand-accent":
      branding?.accentColor ??
      "#d19a2a",
    "--brand-background":
      branding?.backgroundColor ??
      "#eef2f0"
  } as React.CSSProperties;

  return (
    <main
      className="brand-shell"
      style={style}
    >
      <section className="brand-card">
        <header className="brand-header">
          <img
            className="camp-logo"
            src={
              branding?.logoUrl ||
              "/frontier-logo-transparent.png"
            }
            alt={
              branding
                ? `${branding.campName} logo`
                : "Camp logo"
            }
          />

          <div>
            {eyebrow && (
              <div className="eyebrow">
                {eyebrow}
              </div>
            )}
            <h1>
              {branding?.campName ??
                "Camp Points V3"}
            </h1>
          </div>
        </header>

        {children}
      </section>
    </main>
  );
}
